module.exports = __webpack_public_path__ + "img/cloud-snow.c5d86187.svg";